import type { ComponentProps } from "react";

import { useBoolean } from "@/shared/hooks";
import { Input } from "@/shared/ui";
import { EyeClosedIcon, EyeIcon, LockIcon } from "../icons";

export const PasswordInput = ({
  ...props
}: ComponentProps<typeof Input.Root>) => {
  const { value: passwordVisible, toggle: togglePasswordVisibility } =
    useBoolean(false);

  return (
    <Input.Root type={passwordVisible ? "text" : "password"} {...props}>
      <Input.Slot>
        <LockIcon />
      </Input.Slot>

      <Input.Slot asChild>
        <button type="button" onClick={togglePasswordVisibility}>
          {passwordVisible ? <EyeIcon /> : <EyeClosedIcon />}
        </button>
      </Input.Slot>
    </Input.Root>
  );
};
